






































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { Comment } from '@/api/model/comment'
import { isAllowedUserForReferral } from '@/helpers/security'

@Component
export default class ColumnTitle extends Vue {
    @Prop({ required: true }) referral!: Referral

    routeToDetail(referral: Referral) {
        if (!isAllowedUserForReferral(this.$currentUser, referral) && this.$currentUser.betaOptInEnabled) {
            return {
                name: 'one_contact_detail',
                params: {
                    contactId: referral.contact.id,
                    toOne: this.$currentUser.betaOptInEnabled,
                },
            }
        }

        return {
            name: 'tasks_detail',
            params: {
                referralId: referral.id,
                contactId: referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }

    filterComments(referral: Referral) {
        return referral.comments
            .filter(comment => comment instanceof Comment)
            .sort((a: Comment, b: Comment) => a.createdAt > b.createdAt ? -1 : 1)
    }
}
